const DEFAULT_BASE_URL = 'https://blops-ia-api.blops.com.br'

import uploadFileToBlob from '../pages/Leads/Upload/azureBlob'

/**
 * @param {File} file - Arquivo a ser enviado
 * @param {string} containerName - Nome do container (ex: 'autos', 'publicacoes')
 * @returns {Promise<string>} - URL do arquivo no Azure
 */
const uploadFileToAzure = async (file, containerName = 'autos', numeroProcesso = null) => {
  try {
    if (!file) return null
  
    const storageAccountName = window.sessionStorage.getItem("STORAGE_ACCOUNTNAME")
    const sasToken = containerName === 'autos' 
      ? window.sessionStorage.getItem("STORAGE_SASTOKEN_AUTOS")
      : window.sessionStorage.getItem("STORAGE_SASTOKEN_PUBLI")
    
    if (!storageAccountName || !sasToken) {
      console.warn('Azure Storage não configurado. Pulando upload para Azure.')
      return null
    }
    
    // Se há número do processo, usa como nome do arquivo, senão usa o nome original
    const fileName = numeroProcesso ? numeroProcesso.replace("/", "-") : file.name
    
    // Cria um novo arquivo com o nome correto
    const fileWithProcessName = new File([file], fileName, {
      type: file.type,
    })
    
    await uploadFileToBlob(fileWithProcessName, containerName)
    
    const azureFileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`
    
    // Dispara evento customizado para notificar que um arquivo foi enviado
    const event = new CustomEvent('fileUploadedToAzure', {
      detail: {
        fileName: fileName,
        originalFileName: file.name,
        containerName: containerName,
        azureFileUrl: azureFileUrl,
        timestamp: new Date().toISOString()
      }
    })
    window.dispatchEvent(event)
    
    return azureFileUrl
  } catch (error) {
    console.error('Erro ao fazer upload para Azure:', error)
    return null
  }
}

export async function aiSendMessage({ message, userId, conversationId = '', jobId = '', file = null, numeroProcesso = null, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const isMultipart = !!file
  let res
  if (isMultipart) {
    let azureFileUrl = null
    if (file) {
      console.log('Fazendo upload do arquivo para Azure...')
      // Se há número do processo, usa como nome do arquivo
      azureFileUrl = await uploadFileToAzure(file, 'autos', numeroProcesso)
      if (azureFileUrl) {
        console.log('Arquivo enviado para Azure:', azureFileUrl)
      }
    }
    
    const form = new FormData()
    if (typeof message === 'string') form.append('message', message)
    if (userId) form.append('user_id', userId)
    form.append('conversation_id', '')
    if (file) form.append('file', file, file.name)
    if (azureFileUrl) form.append('azure_file_url', azureFileUrl)

    res = await fetch(`${baseUrl}/messages/form`, {
      method: 'POST',
      body: form,
      signal
    })
  } else {
    const body = {
      message
    }
    if (userId) body.user_id = userId
    if (conversationId) body.conversation_id = conversationId
    if (jobId) body.job_id = jobId

    res = await fetch(`${baseUrl}/messages`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal
    })
  }

  if (!res.ok) {
    throw new Error(`IA POST /messages falhou: HTTP ${res.status}`)
  }
  return res.json()
}

export async function aiSendQualificacaoMessage({ message, userId, idProcesso, conversationId = '', signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  
  const body = {
    user_id: userId,
    message: message,
    id_processo: idProcesso
  }

  const res = await fetch(`${baseUrl}/publicacoes/messages`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    signal
  })

  if (!res.ok) {
    throw new Error(`IA POST /publicacoes/messages falhou: HTTP ${res.status}`)
  }
  return res.json()
}

export async function aiWaitForQualificacaoResult(id, { userId, pollIntervalMs = 1000, maxWaitMs = 60000, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const startedAt = Date.now()

  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (signal?.aborted) {
      const abortError = new Error('Aborted')
      abortError.name = 'AbortError'
      throw abortError
    }

    const params = new URLSearchParams()
    if (userId) params.set('user_id', userId)
    const url = params.toString()
      ? `${baseUrl}/messages/${encodeURIComponent(id)}?${params.toString()}`
      : `${baseUrl}/messages/${encodeURIComponent(id)}`
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal
    })
    if (!res.ok) {
      throw new Error(`IA GET /messages/${id} falhou: HTTP ${res.status}`)
    }
    const data = await res.json()

    const status = (data?.status || '').toLowerCase()
    if (status === 'succeeded' || status === 'failed') {
      return data
    }

    if (Date.now() - startedAt > maxWaitMs) {
      throw new Error('Timeout aguardando resposta da IA')
    }

    await new Promise(r => setTimeout(r, pollIntervalMs))
  }
}


export async function aiWaitForResult(id, { userId, pollIntervalMs = 1000, maxWaitMs = 60000, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const startedAt = Date.now()

  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (signal?.aborted) {
      const abortError = new Error('Aborted')
      abortError.name = 'AbortError'
      throw abortError
    }

    const params = new URLSearchParams()
    if (userId) params.set('user_id', userId)
    const url = params.toString()
      ? `${baseUrl}/messages/${encodeURIComponent(id)}?${params.toString()}`
      : `${baseUrl}/messages/${encodeURIComponent(id)}`
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      signal
    })
    if (!res.ok) {
      throw new Error(`IA GET /messages/${id} falhou: HTTP ${res.status}`)
    }
    const data = await res.json()

    const status = (data?.status || '').toLowerCase()
    if (status === 'succeeded' || status === 'failed') {
      return data
    }

    if (Date.now() - startedAt > maxWaitMs) {
      throw new Error('Timeout aguardando resposta da IA')
    }

    await new Promise(r => setTimeout(r, pollIntervalMs))
  }
}

export function aiExtractLatestText(apiPayload) {
  try {
    const latest = apiPayload?.messages?.[0]
    return latest?.text || ''
  } catch (_) {
    return ''
  }
}

// Conversas
export async function aiCreateConversation({ userId, title = '', signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const params = new URLSearchParams()
  if (userId) params.set('user_id', userId)
  if (title) params.set('title', title)
  const res = await fetch(`${baseUrl}/conversations?${params.toString()}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    signal
  })
  if (!res.ok) throw new Error(`IA POST /conversations falhou: HTTP ${res.status}`)
  return res.json()
}

export async function aiListConversations({ userId, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const params = new URLSearchParams()
  if (userId) params.set('user_id', userId)
  const res = await fetch(`${baseUrl}/conversations?${params.toString()}`, { signal })
  if (!res.ok) throw new Error(`IA GET /conversations falhou: HTTP ${res.status}`)
  return res.json()
}

export async function aiGetConversation({ userId, conversationId, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const params = new URLSearchParams()
  if (userId) params.set('user_id', userId)
  const res = await fetch(`${baseUrl}/conversations/${encodeURIComponent(conversationId)}?${params.toString()}`, { signal })
  if (!res.ok) throw new Error(`IA GET /conversations/${conversationId} falhou: HTTP ${res.status}`)
  return res.json()
}

export async function aiRenameConversation({ userId, conversationId, title, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const params = new URLSearchParams()
  if (userId) params.set('user_id', userId)
  const res = await fetch(`${baseUrl}/conversations/${encodeURIComponent(conversationId)}?${params.toString()}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ title }),
    signal
  })
  if (!res.ok) throw new Error(`IA PATCH /conversations/${conversationId} falhou: HTTP ${res.status}`)
  return res.json()
}

export async function aiDeleteConversation({ userId, conversationId, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const params = new URLSearchParams()
  if (userId) params.set('user_id', userId)
  const res = await fetch(`${baseUrl}/conversations/${encodeURIComponent(conversationId)}?${params.toString()}`, {
    method: 'DELETE',
    signal
  })
  if (!res.ok) throw new Error(`IA DELETE /conversations/${conversationId} falhou: HTTP ${res.status}`)
  return res.json()
}

export async function aiGetConversationMessages({ userId, conversationId, limit = 50, order = 'asc', refresh = false, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  const params = new URLSearchParams()
  if (userId) params.set('user_id', userId)
  params.set('limit', String(limit))
  params.set('order', order)
  if (refresh) params.set('refresh', 'true')
  const res = await fetch(`${baseUrl}/conversations/${encodeURIComponent(conversationId)}/messages?${params.toString()}`, { signal })
  if (!res.ok) throw new Error(`IA GET /conversations/${conversationId}/messages falhou: HTTP ${res.status}`)
  return res.json()
}

export async function aiSendPublicacoesMessage({ message, userId, idProcesso, conversationId = null, newConversation = false, file = null, numeroProcesso = null, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  
  let azureFileUrl = null
  if (file) {
    console.log('Fazendo upload do arquivo para Azure...')
    // Para publicações, usa o numeroProcesso como nome do arquivo (numeroCNJ)
    azureFileUrl = await uploadFileToAzure(file, 'autos', numeroProcesso)
    if (azureFileUrl) {
      console.log('Arquivo enviado para Azure:', azureFileUrl)
    }
  }
  
  const form = new FormData()
  if (typeof message === 'string') form.append('message', message)
  if (userId) form.append('user_id', userId)
  if (idProcesso) form.append('id_processo', idProcesso)
  form.append('conversation_id', '')
  if (newConversation !== undefined) form.append('new_conversation', newConversation.toString())
  if (file) form.append('file', file, file.name)
  if (azureFileUrl) form.append('azure_file_url', azureFileUrl)

  const res = await fetch(`${baseUrl}/publicacoes/messages/form`, {
    method: 'POST',
    body: form,
    signal
  })

  if (!res.ok) {
    throw new Error(`IA POST /publicacoes/messages/form falhou: HTTP ${res.status}`)
  }
  return res.json()
}

export async function aiCleanupPublicacoesConversation({ conversationId, userId, signal } = {}) {
  const baseUrl = process.env.REACT_APP_IA_API_BASE || DEFAULT_BASE_URL
  
  console.log('aiCleanupPublicacoesConversation chamada:', { conversationId, userId })
  
  const params = new URLSearchParams()
  if (userId) params.set('user_id', userId)
  
  const url = params.toString()
    ? `${baseUrl}/publicacoes/conversations/${encodeURIComponent(conversationId)}/cleanup?${params.toString()}`
    : `${baseUrl}/publicacoes/conversations/${encodeURIComponent(conversationId)}/cleanup`
  
  console.log('URL do cleanup:', url)
  
  const res = await fetch(url, {
    method: 'DELETE',
    signal
  })

  console.log('Resposta do cleanup:', res.status, res.statusText)

  if (!res.ok) {
    throw new Error(`IA DELETE /publicacoes/conversations/${conversationId}/cleanup falhou: HTTP ${res.status}`)
  }
  return res.json()
}


